import "./chunk--chunk-RQ7252KT.js";

// src/js/components/QuickAdd.js
var QuickAdd = class {
  constructor(el, sel) {
    this.el = el;
    this.product = el.getAttribute(sel);
    this.toggles = el.querySelectorAll("[data-quick-add-toggle]");
    this.content = el.querySelector("[data-quick-add-content]");
    this.atc = el.querySelector("button[type='submit']");
  }
  init() {
    this.initEventListener();
    this.initCloseListeners();
  }
  initEventListener() {
    this.toggles.forEach((toggle) => toggle.addEventListener("click", () => {
      document.querySelectorAll("[data-quick-add-content]").forEach((el) => {
        if (el !== this.content) {
          el.classList.remove("active");
        }
      });
      this.content.classList.add("active");
    }));
  }
  initCloseListeners() {
    document.addEventListener("click", (e) => {
      if (this.content.classList.contains("active")) {
        if (!e.target.closest("[data-quick-add-toggle]") && !e.target.closest("[data-quick-add-content]")) {
          this.content.classList.remove("active");
        }
      }
    });
  }
};
var QuickAdd_default = QuickAdd;
export {
  QuickAdd_default as default
};
